import { render, staticRenderFns } from "./ShowView.vue?vue&type=template&id=55c53c46&scoped=true&"
import script from "./ShowView.vue?vue&type=script&lang=js&"
export * from "./ShowView.vue?vue&type=script&lang=js&"
import style0 from "./ShowView.vue?vue&type=style&index=0&id=55c53c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c53c46",
  null
  
)

export default component.exports